module.exports = __webpack_public_path__ + "img/n6.4f03de10.png";